'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var valueExist = function valueExist(value1) {
  return value1 || value1 === 0 ? true : false;
};

var getValue = function getValue(value1) {
  return valueExist(value1) ? value1 : false;
}; // If the value passed in is a number we will add px, otherwise if it is a string the unit should be included (px, %, vw)


var formatValue = function formatValue(value) {
  if (typeof value === 'number') {
    return "".concat(value, "px");
  }

  return value;
}; // You can pass in props.padding as a number, string, or an object which has the following props left, right, top, bottom, horizontal, vertical
// Or you can pass in props.padding, props.paddingLeft, props.paddingVertical...


var addPadding = function addPadding(props) {
  var paddingAll = typeof props.padding === 'number' || typeof props.padding === 'string' ? props.padding : false;
  var padding = props.padding || {};
  var paddingHorizontal = getValue(padding.horizontal) || getValue(props.paddingHorizontal);
  var paddingVertical = getValue(padding.vertical) || getValue(props.paddingVertical);
  var paddingLeft = getValue(padding.left) || getValue(props.paddingLeft);
  var paddingRight = getValue(padding.right) || getValue(props.paddingRight);
  var paddingTop = getValue(padding.top) || getValue(props.paddingTop);
  var paddingBottom = getValue(padding.bottom) || getValue(props.paddingBottom);
  var styles = []; // Generic Padding

  if (valueExist(paddingAll)) {
    styles.push("padding: ".concat(formatValue(paddingAll), ";"));
  } // Horizontal / Vertical Padding


  if (valueExist(paddingHorizontal) && valueExist(paddingVertical)) {
    styles.push("padding: ".concat(formatValue(paddingVertical), " ").concat(formatValue(paddingHorizontal), ";"));
  } else if (valueExist(paddingHorizontal)) {
    styles.push("padding-left: ".concat(formatValue(paddingHorizontal), ";"));
    styles.push("padding-right: ".concat(formatValue(paddingHorizontal), ";"));
  } else if (valueExist(paddingVertical)) {
    styles.push("padding-top: ".concat(formatValue(paddingVertical), ";"));
    styles.push("padding-bottom: ".concat(formatValue(paddingVertical), ";"));
  } // Detailed Padding


  if (valueExist(paddingLeft)) {
    styles.push("padding-left: ".concat(formatValue(paddingLeft), ";"));
  }

  if (valueExist(paddingRight)) {
    styles.push("padding-right: ".concat(formatValue(paddingRight), ";"));
  }

  if (valueExist(paddingTop)) {
    styles.push("padding-top: ".concat(formatValue(paddingTop), ";"));
  }

  if (valueExist(paddingBottom)) {
    styles.push("padding-bottom: ".concat(formatValue(paddingBottom), ";"));
  }

  return styles.join(';');
};

var addMargin = function addMargin(props) {
  var marginAll = typeof props.margin === 'number' || typeof props.margin === 'string' ? props.margin : false;
  var margin = props.margin || {};
  var marginHorizontal = getValue(margin.horizontal) || getValue(props.marginHorizontal);
  var marginVertical = getValue(margin.vertical) || getValue(props.marginVertical);
  var marginLeft = getValue(margin.left) || getValue(props.marginLeft);
  var marginRight = getValue(margin.right) || getValue(props.marginRight);
  var marginTop = getValue(margin.top) || getValue(props.marginTop);
  var marginBottom = getValue(margin.bottom) || getValue(props.marginBottom);
  var styles = []; // Generic Margin

  if (valueExist(marginAll)) {
    styles.push("margin: ".concat(formatValue(marginAll), ";"));
  } // Horizontal / Vertical Margin


  if (valueExist(marginHorizontal) && valueExist(marginVertical)) {
    styles.push("margin: ".concat(formatValue(marginVertical), " ").concat(formatValue(marginHorizontal), ";"));
  } else if (valueExist(marginHorizontal)) {
    styles.push("margin-left: ".concat(formatValue(marginHorizontal), ";"));
    styles.push("margin-right: ".concat(formatValue(marginHorizontal), ";"));
  } else if (valueExist(marginVertical)) {
    styles.push("margin-top: ".concat(formatValue(marginVertical), ";"));
    styles.push("margin-bottom: ".concat(formatValue(marginVertical), ";"));
  } // Detailed Margin


  if (valueExist(marginLeft)) {
    styles.push("margin-left: ".concat(formatValue(marginLeft), ";"));
  }

  if (valueExist(marginRight)) {
    styles.push("margin-right: ".concat(formatValue(marginRight), ";"));
  }

  if (valueExist(marginTop)) {
    styles.push("margin-top: ".concat(formatValue(marginTop), ";"));
  }

  if (valueExist(marginBottom)) {
    styles.push("margin-bottom: ".concat(formatValue(marginBottom), ";"));
  }

  return styles.join(';');
};

var boxSpacing = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addMargin: addMargin,
    addPadding: addPadding
});

// Colors
var A = '#AAAAAA';
var B = '#BBBBBB';
var C = '#CCCCCC';
var D = '#DDDDDD';
var E = '#EEEEEE';
var F = '#FFFFFF';
var $0 = '#000000';
var $1 = '#111111';
var $2 = '#222222';
var $3 = '#333333';
var $4 = '#444444';
var $5 = '#555555';
var $6 = '#666666';
var $7 = '#777777';
var $8 = '#888888';
var $9 = '#999999';
var AB = '#ABABAB';
var A0 = '#A0A0A0';
var A3 = '#A3A3A3';
var A8 = '#A8A8A8';
var A9 = '#A9A9A9';
var BE = '#BEBEBE';
var B3 = '#B3B3B3';
var BD = '#BDBDBD';
var B6 = '#B6B6B6';
var B8 = '#B8B8B8';
var C4 = '#C4C4C4';
var DA = '#DADADA';
var D2 = '#D2D2D2';
var D3 = '#D3D3D3';
var D4 = '#D4D4D4';
var D6 = '#D6D6D6';
var D9 = '#D9D9D9';
var EB = '#EBEBEB';
var EC = '#ECECEC';
var ED = '#EDEDED';
var E1 = '#E1E1E1';
var E2 = '#E2E2E2';
var E5 = '#E5E5E5';
var FA = '#FAFAFA';
var FC = '#FCFCFC';
var F0 = '#F0F0F0';
var F1 = '#F1F1F1';
var F2 = '#F2F2F2';
var F3 = '#F3F3F3';
var F4 = '#F4F4F4';
var F5 = '#F5F5F5';
var F6 = '#F6F6F6';
var F7 = '#F7F7F7';
var F8 = '#F8F8F8';
var F9 = '#F9F9F9';
var $12 = '#121212';
var $13 = '#131313';
var $16 = '#161616';
var $19 = '#191919';
var $2C = '#2C2C2C';
var $25 = '#252525';
var $26 = '#262626';
var $27 = '#272727';
var $28 = '#282828';
var $2F = '#2F2F2F';
var $31 = '#313131';
var $32 = '#323232';
var $34 = '#343434';
var $35 = '#353535';
var $3C = '#3C3C3C';
var $45 = '#454545';
var $4A = '#4A4A4A';
var $47 = '#474747';
var $5A = '#5A5A5A';
var $50 = '#505050';
var $62 = '#626262';
var $7D = '#7D7D7D';
var $7E = '#7E7E7E';
var $76 = '#767676';
var $86 = '#868686';
var $8D = '#8D8D8D';
var $96 = '#969696';
var $98 = '#989898';
var $9E = '#9E9E9E';
var $9F = '#9F9F9F';
var red = '#D0021B';
var blue18 = '#0183DA';
var blue16 = '#016FB8';
var blue19 = '#0197FC';
var blue33 = '#33A0D9';
var blue34 = '#34a3ed';
var yellow = '#FFC000';
var greyE5 = '#E5E5E4';
var indicator_green = '#4b9448'; // old color #00D16B;

var indicator_red = '#C8102E'; //#F32D3D;

var indicator_yellow = '#FFB81C';
var disabled_color = C4;

var colors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    A: A,
    B: B,
    C: C,
    D: D,
    E: E,
    F: F,
    $0: $0,
    $1: $1,
    $2: $2,
    $3: $3,
    $4: $4,
    $5: $5,
    $6: $6,
    $7: $7,
    $8: $8,
    $9: $9,
    AB: AB,
    A0: A0,
    A3: A3,
    A8: A8,
    A9: A9,
    BE: BE,
    B3: B3,
    BD: BD,
    B6: B6,
    B8: B8,
    C4: C4,
    DA: DA,
    D2: D2,
    D3: D3,
    D4: D4,
    D6: D6,
    D9: D9,
    EB: EB,
    EC: EC,
    ED: ED,
    E1: E1,
    E2: E2,
    E5: E5,
    FA: FA,
    FC: FC,
    F0: F0,
    F1: F1,
    F2: F2,
    F3: F3,
    F4: F4,
    F5: F5,
    F6: F6,
    F7: F7,
    F8: F8,
    F9: F9,
    $12: $12,
    $13: $13,
    $16: $16,
    $19: $19,
    $2C: $2C,
    $25: $25,
    $26: $26,
    $27: $27,
    $28: $28,
    $2F: $2F,
    $31: $31,
    $32: $32,
    $34: $34,
    $35: $35,
    $3C: $3C,
    $45: $45,
    $4A: $4A,
    $47: $47,
    $5A: $5A,
    $50: $50,
    $62: $62,
    $7D: $7D,
    $7E: $7E,
    $76: $76,
    $86: $86,
    $8D: $8D,
    $96: $96,
    $98: $98,
    $9E: $9E,
    $9F: $9F,
    red: red,
    blue18: blue18,
    blue16: blue16,
    blue19: blue19,
    blue33: blue33,
    blue34: blue34,
    yellow: yellow,
    greyE5: greyE5,
    indicator_green: indicator_green,
    indicator_red: indicator_red,
    indicator_yellow: indicator_yellow,
    disabled_color: disabled_color
});

// Native Fonts
// Android maps Droid and Roboto fonts via their system_fonts.xml
// Reference: https://github.com/android/platform_frameworks_base/blob/master/data/fonts/system_fonts.xml
// iOS Fonts:                                             // Android Fonts:
var anDb = "AvenirNext-DemiBold";
var rB = "sans-serif"; // must include font-weight: bold;

var ancDb = "AvenirNextCondensed-DemiBold";
var ancM = "AvenirNextCondensed-Medium";
var anM = "AvenirNext-Medium";
var rM = "sans-serif-medium";
var anR = "AvenirNext-Regular";
var rR = "sans-serif";
var ancB = "AvenirNextCondensed-Bold";
var rcB = "sans-serif-condensed"; // must include font-weight: bold;

var rCl = "sans-serif-condensed-light";
var rCr = "sans-serif-condensed"; // font-families

var hnCb = "HelveticaNeue-CondensedBold";
var os = "OpenSans";
var osCb = "OpenSans-CondensedBold";
var osCl = "OpenSans-CondensedLight";

var fonts = /*#__PURE__*/Object.freeze({
    __proto__: null,
    anDb: anDb,
    rB: rB,
    ancDb: ancDb,
    ancM: ancM,
    anM: anM,
    rM: rM,
    anR: anR,
    rR: rR,
    ancB: ancB,
    rcB: rcB,
    rCl: rCl,
    rCr: rCr,
    hnCb: hnCb,
    os: os,
    osCb: osCb,
    osCl: osCl
});

var phoneOnly = '@media (max-width: 599px)';
var tabletPortraitAndDown = '@media (max-width: 899px)';
var tabletPortraitOnly = '@media (min-width: 600px) and (max-width: 899px)';
var tabletPortraitUp = '@media (min-width: 600px)';
var tabletLandscapeAndDown = '@media (max-width: 1309px)';
var tabletLandscapeOnly = '@media (min-width: 900px) and (max-width: 1309px)';
var tabletLandscapeUp = '@media (min-width: 900px)';
var tabletPortraitOrLandscape = '@media (min-width: 600px) and (max-width: 1309px)';
var desktopUp = '@media (min-width: 1310px)';
var transition = function transition(duration) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }

  return "\n    transition-property: ".concat(properties.join(', '), ";\n    transition-duration: ").concat(duration, ";\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    transition-delay: 0ms;\n");
};

var mixins = /*#__PURE__*/Object.freeze({
    __proto__: null,
    phoneOnly: phoneOnly,
    tabletPortraitAndDown: tabletPortraitAndDown,
    tabletPortraitOnly: tabletPortraitOnly,
    tabletPortraitUp: tabletPortraitUp,
    tabletLandscapeAndDown: tabletLandscapeAndDown,
    tabletLandscapeOnly: tabletLandscapeOnly,
    tabletLandscapeUp: tabletLandscapeUp,
    tabletPortraitOrLandscape: tabletPortraitOrLandscape,
    desktopUp: desktopUp,
    transition: transition
});

exports.boxSpacing = boxSpacing;
exports.colors = colors;
exports.fonts = fonts;
exports.mixins = mixins;
